<script>
  import { alert } from 'vue-strap'; 
  
  export default {
    components: { alert },
    props: {
      rateios: {
        type: Array,
        required: true,
      },
      declaracaoIniciada: {
        type: Boolean,
        default: false, 
      },
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    methods: {
      deletarItem(indice) {
        this.rateios.splice(indice, 1);
      },
    },
  }
</script>

<template>
  <div>
    <div class="bs-callout bs-callout-success no-margin-top" v-for="(rateio, index) in rateios">

      <h4 class="text-success">
        Despesa #{{ index + 1 }}

        <button
          type="button"
          class="btn btn-sm btn-danger btn-delete-item"
          title="Excluir item"
          @click="deletarItem(index)"
          v-if="!relatorio && !declaracaoIniciada">
          <i class="fa fa-trash"></i>
        </button>

        <button
          type="button"
          class="btn btn-xs btn-primary btn-delete-item cursor-default"
          v-if="!relatorio && declaracaoIniciada && rateio.validade === 1">
          <i class="fa fa-check"></i> Aprovado
        </button>

        <button
          type="button"
          class="btn btn-xs btn-warning btn-delete-item cursor-default"
          v-if="!relatorio && declaracaoIniciada && rateio.validade === null">
          <i class="fa fa-warning"></i> Não analisado
        </button>

        <button
          type="button"
          class="btn btn-xs btn-danger btn-delete-item cursor-default"
          v-if="!relatorio && declaracaoIniciada && rateio.validade === 2">
          <i class="fa fa-close"></i> Reprovado
        </button>
      </h4>
      
      <div class="row" v-if="rateio.observacao !== 'VALOR NÃO UTILIZADO'">
        <dl :class="[declaracaoIniciada ? 'col-md-3' : 'col-md-4']">
          <dt>CPF/CNPJ</dt>
          <dd>{{ rateio.cpfCnpj }}</dd>
        </dl>
        <dl :class="[declaracaoIniciada ? 'col-md-3' : 'col-md-4']">
          <dt>Pessoa/Empresa</dt>
          <dd>{{ rateio.nome }}</dd>
        </dl>
        <dl :class="[declaracaoIniciada ? 'col-md-3' : 'col-md-4']">
          <dt>Valor</dt>
          <dd>{{ rateio.valor }}</dd>
        </dl>
        <dl class="col-md-3" v-if="declaracaoIniciada">
          <dt>Valor aprovado</dt>
          <dd>{{ rateio.valorValidado | formatarNumero }}</dd>
        </dl>
      </div>

      <div class="row" v-if="rateio.observacao && rateio.observacao !== 'VALOR NÃO UTILIZADO'">
        <dl class="col-md-12">
          <dt>Observação</dt>
          <dd>{{ rateio.observacao }}</dd>
        </dl>
      </div>

      <div class="row" v-if="rateio.observacaoAnalise">
        <dl class="col-md-12">
          <dt>Observação da análise</dt>
          <dd>{{ rateio.observacaoAnalise }}</dd>
        </dl>
      </div>

      <alert type="warning" style="margin-top: 17px" v-if="rateio.observacao === 'VALOR NÃO UTILIZADO'">
        <i class="fa fa-warning"></i> Valor não utilizado
      </alert>
      
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/compartilhado/ListaRateioDespesasRubricas.vue